<template>
  <div style="position: fixed; bottom: 3em; width: 100%; z-index: 10000;" >
    <TransitionGroup>
        <v-row
          class="mr-5"
          justify="end"
          v-for="notifica in notifiche.notifications"
          :key="notifica.id"
        >
          <v-col cols="10" md="3" class="pa-1">
            <Notifica :notifica="notifica" />
          </v-col>
        </v-row>
      </TransitionGroup>
  </div>
</template>

<script setup>
import { useNotifications } from "@/store/notification";
import Notifica from "@/components/Notifica.vue";

const notifiche = useNotifications();
</script>


<style>

/* we will explain what these classes do next! */
  .v-enter-active,
  .v-leave-active {
    transition: all .4s ease;
    position: relative;
  }

  .v-leave-to {
    left: 1000px;
  }

  .v-enter-from {
    left: 0px;
    opacity: 0;
  }

  .v-enter-to,
  .v-leave-from {
    left: 0px;
    opacity: 1;
  }

</style>